import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isNil from "lodash/isNil";
import _size from "lodash/size";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import { Feedbacks } from '@datacamp/le-shared-components';
import * as React from 'react';
import { setHintShown } from './actions';
import { useDispatch } from './reduxHooks';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const Feedback = _ref => {
  let {
    exerciseId,
    feedbackMessages,
    hideOpenAIBranding,
    hideTakeHint,
    hintCost,
    hintShown,
    maxTimesToShowSolution,
    onRateFeedback,
    onTakeHint,
    onTakeSolution,
    remainingXp,
    solutionShown,
    title
  } = _ref;
  const dispatch = useDispatch();
  const [currentFeedbackIndex, setCurrentFeedbackIndex] = React.useState(feedbackMessages.length - 1);
  const feedbackRef = React.createRef();
  React.useEffect(() => {
    if (_size(feedbackMessages) > 0 && !_isNil(feedbackRef.current)) {
      feedbackRef.current.focus();
    }
    setCurrentFeedbackIndex(feedbackMessages.length - 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [feedbackMessages.length, solutionShown]); // update only when the ids array change or solution is taken

  const setHintShownCb = React.useCallback(shown => dispatch(setHintShown({
    exerciseId,
    hintShown: shown
  })), [dispatch, exerciseId]);
  const hintAndSolutionButtonProps = React.useMemo(() => hintShown ? {
    isSolution: true,
    isSolutionShown: solutionShown > 0,
    isVisible: onTakeSolution !== undefined && solutionShown < maxTimesToShowSolution,
    onClick: onTakeSolution,
    xp: remainingXp
  } : {
    isSolution: false,
    isSolutionShown: solutionShown > 0,
    isVisible: !hideTakeHint,
    onClick: onTakeHint,
    xp: hintCost
  }, [hideTakeHint, hintCost, hintShown, maxTimesToShowSolution, onTakeHint, onTakeSolution, remainingXp, solutionShown]);
  const feedbackMessagesWithOnRate = React.useMemo(() => feedbackMessages.map((feedbackMessage, feedbackMessageIndex) => _objectSpread(_objectSpread({}, feedbackMessage), {}, {
    isActive: feedbackMessageIndex === currentFeedbackIndex,
    rating: _objectSpread(_objectSpread({}, feedbackMessage.rating), {}, {
      onRate: _ref2 => {
        let {
          isUseful,
          message
        } = _ref2;
        onRateFeedback({
          feedbackMessage,
          feedbackMessageId: feedbackMessage.id,
          isUseful,
          userFeedback: message
        });
      }
    })
  })), [feedbackMessages, currentFeedbackIndex, onRateFeedback]);
  const feedbackMessagesWithSetHintShown = React.useMemo(() => feedbackMessagesWithOnRate.map(feedbackMessage => {
    if (feedbackMessage.aiAssistantProps == null) {
      return feedbackMessage;
    }
    return _objectSpread(_objectSpread({}, feedbackMessage), {}, {
      aiAssistantProps: _objectSpread(_objectSpread({}, feedbackMessage.aiAssistantProps), {}, {
        setHintShown: setHintShownCb
      })
    });
  }), [feedbackMessagesWithOnRate, setHintShownCb]);
  return ___EmotionJSX(Feedbacks, {
    feedbackMessages: feedbackMessagesWithSetHintShown,
    hideOpenAIBranding: hideOpenAIBranding,
    hintAndSolution: hintAndSolutionButtonProps,
    innerRef: feedbackRef,
    key: title,
    onClickTab: setCurrentFeedbackIndex
  });
};